// Global JavaScript for MM 2025 theme

// Collage Section Interaction
function initCollageInteraction() {
  // Wait for elements to be available
  setTimeout(function () {
    const images = document.querySelectorAll(".collage-images__item");
    const captions = document.querySelectorAll(".collage-captions__item");

    if (images.length === 0) {
      setTimeout(initCollageInteraction, 1000);
      return;
    }

    // Match by data attributes
    images.forEach(function (image) {
      const imageId = image.dataset.imageId;
      const correspondingCaption = document.querySelector(
        `[data-caption-for="${imageId}"]`
      );

      if (correspondingCaption) {
        image.addEventListener("mouseenter", function () {
          correspondingCaption.classList.add("active");
        });

        image.addEventListener("mouseleave", function () {
          correspondingCaption.classList.remove("active");
        });
      }
    });
  }, 500);
}

// Accordion Functionality (for .accordion in archive and faqs)
function initAccordionFunctionality() {
  const accordions = document.querySelectorAll(".accordion");

  const toggleAccordion = (accordionButton) => {
    const symbol = accordionButton.querySelector(".accordion__symbol");
    // Close other accordion items
    accordions.forEach((otherAccordion) => {
      const otherAccordionButton = otherAccordion.querySelector("button");
      const otherSymbol =
        otherAccordionButton.querySelector(".accordion__symbol");
      if (otherAccordionButton !== accordionButton) {
        otherAccordionButton.setAttribute("aria-expanded", "false");
        otherSymbol.textContent = "+";
      }
    });
    // Expand the accordion
    if (accordionButton.getAttribute("aria-expanded") !== "true") {
      accordionButton.setAttribute("aria-expanded", "true");
      symbol.textContent = "-";
    } else {
      accordionButton.setAttribute("aria-expanded", "false");
      symbol.textContent = "+";
    }
  };

  accordions.forEach((accordion) => {
    const accordionButton = accordion.querySelector("button");
    if (!accordionButton) return;
    accordionButton.addEventListener("click", () => {
      toggleAccordion(accordionButton);
    });
  });
}

// Splide Carousel Initialization
function initSplideCarousels() {
  const galleries = document.querySelectorAll(
    ".gallery.splide, .product-images__container.splide"
  );
  galleries.forEach(function (gallery) {
    if (gallery && !gallery.classList.contains("splide--initialized")) {
      new Splide(gallery).mount();
      gallery.classList.add("splide--initialized");
    }
  });
}

function initGenericAccordions() {
  document.querySelectorAll(".accordion__button").forEach((button) => {
    // Skip header dropdown accordions to avoid conflicts
    if (button.closest(".header__dropdown-accordion")) {
      return;
    }

    button.addEventListener("click", function () {
      const expanded = this.getAttribute("aria-expanded") === "true";
      this.setAttribute("aria-expanded", !expanded);
      // Toggle icon if present
      const icon = this.querySelector(".accordion__icon");
      if (icon) icon.textContent = expanded ? "+" : "-";
      // Toggle content
      const content = this.nextElementSibling;
      if (content && content.classList.contains("accordion__content")) {
        content.hidden = expanded;
      }
    });
  });
}

// Initialize collage functionality
document.addEventListener("DOMContentLoaded", function () {
  initCollageInteraction();
  initAccordionFunctionality();
  initSplideCarousels();
  initGenericAccordions();
});

// Also initialize on Shopify section events
document.addEventListener("shopify:section:load", function (event) {
  if (event.target.querySelector(".collage-images")) {
    initCollageInteraction();
  }
  if (event.target.querySelector(".accordion")) {
    initAccordionFunctionality();
  }
  if (event.target.querySelector(".accordion__button")) {
    initGenericAccordions();
  }
  if (event.target.querySelector(".gallery.splide")) {
    initSplideCarousels();
  }
});

// Also try again after a short delay in case elements are rendered later
setTimeout(function () {
  initCollageInteraction();
  initSplideCarousels();
}, 1000);
